export enum ValueFlag{
  Low = 'Low',
  High = 'High',
  Normal = 'Normal',
  Abnormal = 'Abnormal',
  Border_High = 'Border Line High',
  Border_Low = 'Border Line Low',
  Nil = '-'
}
